<label [for]="inputId" *ngIf="inputLabel" class="form-label" [ngClass]="{ disabled: isDisabled }">{{
  inputLabel
}}</label>
<input
  [id]="inputId"
  type="text"
  [ngClass]="{ disabled: isDisabled }"
  [class.is-invalid]="errorMessage && touched"
  [attr.aria-label]="inputLabel ? '' : 'Date Input'"
  inputmode="decimal"
  class="form-control"
  [placeholder]="placeholder"
  (input)="maskDate($event.target)"
  (focusout)="validateDate($event.target)"
  [(ngModel)]="_inputText"
  (ngModelChange)="handleChange($event)"
  (blur)="handleTouched()"
/>
<div class="mt-1 text-danger" *ngIf="touched && errorMessage">
  <img src="/assets/images/icons/icon-warning.svg" />
  <span class="small fw-light ps-1">{{ errorMessage }}</span>
</div>
<div
  class="mt-2 small text-emphasis-medium fw-light"
  [ngClass]="{ disabled: isDisabled }"
  *ngIf="helperText && !errorMessage"
>
  {{ helperText }}
</div>
